import React, { useCallback, useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { api } from '../apiClient';
import { useAuth } from '../AuthContext';

export default function NotificationBell() {
  const navigate = useNavigate();
  const { isAuthed } = useAuth();
  const [count, setCount] = useState(0);

  const load = useCallback(async () => {
    if (!isAuthed) { setCount(0); return; }
    try {
      const r = await api.get('/notifications/unread-count');
      setCount(r.data.unread_count ?? r.data.unread ?? 0);
    } catch {
      setCount(0);
    }
  }, [isAuthed]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (!isAuthed) return;
    const interval = setInterval(load, 30000);
    return () => clearInterval(interval);
  }, [isAuthed, load]);

  if (!isAuthed) return null;

  return (
    <button
      data-testid="notification-bell"
      onClick={() => navigate('/notifications')}
      className="relative w-10 h-10 rounded-full bg-white border border-gray-100 flex items-center justify-center hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-pink-500"
    >
      <Bell className="w-5 h-5 text-gray-700" />
      {count > 0 && (
        <span
          data-testid="notif-badge"
          className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] rounded-full bg-red-500 text-white text-[10px] font-black flex items-center justify-center px-1"
        >
          {count > 9 ? '9+' : count}
        </span>
      )}
    </button>
  );
}
